export let additions = {
	none: {
		id: 'none',
		label: 'None',
		width: 0,
		height: 0,
		style: 'none'
	},
	door_3x7: {
		id: 'door_3x7',
		label: 'Door (3x7)',
		width: 3,
		height: 7,
		style: 'door'
	},
	door_4x7: {
		id: 'door_4x7',
		label: 'Door (4x7)',
		width: 4,
		height: 7,
		style: 'door'
	},
	double_door_6x7: {
		id: 'double_door_6x7',
		label: 'Double Door (6x7)',
		width: 6,
		height: 7,
		style: 'double_door'
	},
	window_3x3: {
		id: 'window_3x3',
		label: 'Window (3x3)',
		width: 3,
		height: 3,
		style: 'window'
	},
	window_6x3: {
		id: 'window_6x3',
		label: 'Window (6x3)',
		width: 6,
		height: 3,
		style: 'double_window'
	},
	rollup_8x8: {
		id: 'rollup_8x8',
		label: 'Rollup (8x8)',
		width: 8,
		height: 8,
		style: 'rollup'
	},
	rollup_8x10: {
		id: 'rollup_8x10',
		label: 'Rollup (8x10)',
		width: 8,
		height: 10,
		style: 'rollup'
	},
	rollup_10x8: {
		id: 'rollup_10x8',
		label: 'Rollup (10x8)',
		width: 10,
		height: 8,
		style: 'rollup'
	},
	rollup_10x10: {
		id: 'rollup_10x10',
		label: 'Rollup (10x10)',
		width: 10,
		height: 10,
		style: 'rollup'
	},
	rollup_10x12: {
		id: 'rollup_10x12',
		label: 'Rollup (10x12)',
		width: 10,
		height: 12,
		style: 'rollup'
	},
	rollup_12x10: {
		id: 'rollup_12x10',
		label: 'Rollup (12x10)',
		width: 12,
		height: 10,
		style: 'rollup'
	},
	rollup_12x12: {
		id: 'rollup_12x12',
		label: 'Rollup (12x12)',
		width: 12,
		height: 12,
		style: 'rollup'
	},
	rollup_14x12: {
		id: 'rollup_14x12',
		label: 'Rollup (14x12)',
		width: 14,
		height: 12,
		style: 'rollup'
	},
	rollup_14x14: {
		id: 'rollup_14x14',
		label: 'Rollup (14x14)',
		width: 14,
		height: 14,
		style: 'rollup'
	},
	rollup_14x16: {
		id: 'rollup_14x16',
		label: 'Rollup (14x16)',
		width: 14,
		height: 16,
		style: 'rollup'
	},
	rollup_16x16: {
		id: 'rollup_16x16',
		label: 'Rollup (16x16)',
		width: 16,
		height: 16,
		style: 'rollup'
	},
	rollup_18x16: {
		id: 'rollup_18x16',
		label: 'Rollup (18x16)',
		width: 18,
		height: 16,
		style: 'rollup'
	},
	rollup_20x16: {
		id: 'rollup_20x16',
		label: 'Rollup (20x16)',
		width: 20,
		height: 16,
		style: 'rollup'
	}
};
